import {convertToParamMap, Params} from '@angular/router';
import {ComponentStore} from '@ngrx/component-store';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {createEmptyUtm, Utm} from 'src/app/domain/model/lead/utm.model';

export interface UtmState {
  utm: Utm;
}

const emptyState = () => ({
  utm: createEmptyUtm()
});

@Injectable({
  providedIn: 'root',
})
export default class UtmStore extends ComponentStore<UtmState> {
  public readonly utmInfo$: Observable<Utm> = this.select(state => state.utm);

  constructor(
  ) {
    super(emptyState());
    this.loadFromCookie();
  }

  saveFromUrlQuery(routeParams: Params): void {
    const paramsMap = convertToParamMap(routeParams);
    const utmKeys = paramsMap.keys.filter(key => key.startsWith('utm_'));

    // If there are NO UTMs in the URL, do nothing and keep
    // what we loaded from the cookie in the constructor.
    if (utmKeys.length === 0) {
      return;
    }

    // If there ARE UTMs in the URL, reset and give priority to the URL
    this.reset();
    const newUtmState: UtmState = emptyState();

    utmKeys.forEach((key) => {
      const utmKey = key.substring(4);
      const value = paramsMap.get(key);

      if (value) {
        newUtmState.utm[utmKey] = value;
      }
    });

    this.patchState(() => (newUtmState));
  }

  sync(): Utm {
    return this.get().utm;
  }

  reset(): void {
    this.patchState(() => ({
      ...emptyState()
    }));
  }

  private loadFromCookie(): void {
    const cookie = document.cookie.split('; ').find(row => row.startsWith('finizens_utm='));

    if (cookie) {
      try {
        const cookieVal = cookie.split('=')[1];
        const parsed = JSON.parse(decodeURIComponent(cookieVal));

        // Create a clean UTM object
        const cookieUtm = createEmptyUtm();

        if (parsed.source || parsed.utm_source) {cookieUtm.source = parsed.source || parsed.utm_source;}
        if (parsed.medium || parsed.utm_medium) {cookieUtm.medium = parsed.medium || parsed.utm_medium;}
        if (parsed.campaign || parsed.utm_campaign) {cookieUtm.campaign = parsed.campaign || parsed.utm_campaign;}
        if (parsed.content || parsed.utm_content) {cookieUtm.content = parsed.content || parsed.utm_content;}
        if (parsed.term || parsed.utm_term) {cookieUtm.term = parsed.term || parsed.utm_term;}

        this.patchState({ utm: cookieUtm });

      } catch (e) {
        console.warn('Error parsing UTM cookie in UtmStore', e);
      }
    }
  }
}
